import React from 'react';
import ReactSVG from 'react-svg';
import AllowGifEmoji from '../modules/allowGifEmoji';

const Reactions = ({ data, emojiSrc, getImageCount, cssClass, addReaction }) => (
  <AllowGifEmoji>
    <ul className={`emojis reactions-list ${cssClass || ''}`}>
      {data && emojiSrc && Object.keys(emojiSrc).map(emoji => (
        <li key={emoji}>
          <a href="#" onClick={e => addReaction(e, emoji)}>
            <div className={data.userEmotion.length && data.userEmotion[0].type.toString() === emoji.toString() ? 'voted-emoji' : ''}>
              <ReactSVG src={emojiSrc[emoji]} />
              <span className="fontmulisemi">{getImageCount(emoji).count}</span>
            </div>
          </a>
        </li>))}
    </ul>
  </AllowGifEmoji>
);

export default Reactions;



// WEBPACK FOOTER //
// ./src/components/reactions/Reactions.jsx